var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHottopics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fire_2",
    d: "M19.5 14.4352C19.5 18.5702 16.136 21.9352 12 21.9352C7.864 21.9352 4.5 18.5702 4.5 14.4352C4.5 12.1872 5.142 10.5862 6.646 9.08116C6.941 8.78516 7.275 8.48915 7.621 8.18315C9.037 6.92915 10.5 5.63219 10.5 3.43419C10.5 3.25019 10.602 3.08015 10.764 2.99315C10.926 2.90615 11.123 2.91517 11.277 3.01817C11.337 3.05817 16.915 6.88114 14.055 13.4491C14.726 13.0741 15.529 12.4591 16.022 11.5041C16.338 10.8921 16.499 10.1962 16.499 9.43419C16.499 9.23119 16.622 9.04817 16.81 8.97117C16.996 8.89417 17.213 8.93817 17.356 9.08317C18.719 10.4682 19.5 12.4192 19.5 14.4352Z",
    fill: "#707496"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHottopics);
export default __webpack_public_path__ + "static/media/hottopics.002075f476097d435a9e176b343db3ec.svg";
export { ForwardRef as ReactComponent };